import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { environment } from 'environments/environment';
import { CreditState } from "../credit-state.interface";
import { CreditInterface } from "../../../interfaces/credit/credit.interface";
import { RootState } from "../../product/product.store";

interface UpdateCreditAvanseResponse {
    products: {
        items: any[];
        total: number;
        specialTotal: number;
    };
    credits: CreditInterface[];
}

export const updateCreditAvanseThunk = createAsyncThunk<
  UpdateCreditAvanseResponse, // <-- aici e corect
  { avanse: number; temp: number }
>(
  'credits/updateCreditAvanse',
  async ({ avanse, temp }, { getState }) => {
    const state = getState() as RootState;

    const subscriptionId = state.credit.selectSubscription?.id ?? 0;
    console.log(subscriptionId);

    const result = await axios.post<UpdateCreditAvanseResponse>(
      `${environment.urls.credits.recalculate}`,
      {
        productId: state.credit.productId,
        subscription: subscriptionId,
        avanse,
        temp
      }
    );

    return result.data;
  }
);
